import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CustomerSelectItem, JobsiteSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { EquipmentDetailsService } from '../../equipment-details.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-jobsite',
  templateUrl: './change-jobsite.component.html',
  styleUrls: ['./change-jobsite.component.scss']
})
export class GETChangeJobsiteComponent implements OnInit {


  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  private _implementId: number;
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  selectedCustomer: number;
  selectedJobsite: number;
  saving: boolean = false;
  constructor(private _setupEquipmentService: GETSetupEquipmentService,
    private _equipment: EquipmentDetailsService,
    public dialogRef: MatDialogRef<GETChangeJobsiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, vRef: ViewContainerRef, public toastr: NotificationsService,
  ) {
 
  }

  ngOnInit() {
    this._setupEquipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      this.selectedCustomer = this.data.customerId;
      this.loadJobsitesForCustomer();
    });
    this._equipmentId = this.data.equipmentId;
    this._implementId = this.data.implementId;
  }

  updateJobsiteClicked() {
    if (this.selectedJobsite == null)
      return;
    this.saving = true;
    console.log(this.data)
    if(this._implementId >0){
      console.log("imple", this._implementId)
      this._subscriptions.push(this._equipment.changeInventoryJobsite(this._implementId, this.selectedJobsite).subscribe(succeeded => {
        this.saving = false;
      if (succeeded.m_Item1) {
          this.toastr.success('Jobsite Changed', 'This inventory has been successfully moved to the jobsite ' + succeeded.m_Item2 + '.');
          this.dialogRef.close(succeeded.m_Item2);
      } else {
        console.log(succeeded.m_Item2);
        this.toastr.error('Error', 'Unable to update this inventory jobsite. Please contact TrackTreads support. ');
      }
    }));
    }
    else{
    this._subscriptions.push(this._equipment.changeEquipmentJobsite(this._equipmentId, this.selectedJobsite).subscribe(succeeded => {
        this.saving = false;
      if (succeeded.m_Item1) {
          this.toastr.success('Jobsite Changed', 'This equipment has been successfully moved to the jobsite ' + succeeded.m_Item2 + '.');
          this.dialogRef.close(succeeded.m_Item2);
      } else {
        console.log(succeeded.m_Item2);
        this.toastr.error('Error', 'Unable to update this equipments jobsite. Please contact TrackTreads support. ');
      }
    }));
  }
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
          return;
    this.selectedJobsite = null;
    this.jobsiteList = [];
    this._subscriptions.push(this._setupEquipmentService.getJobsiteList(this.selectedCustomer).subscribe(jobsites => {
        this.jobsiteList = jobsites;
    }));
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  onNoClick(): void {
    this.dialogRef.close('New Site Name');
  }

}
